import {
  GetFulfillmentVariantsBuilder,
  CreateFulfillmentVariantsBuilder,
} from '../fulfillment-variants/fulfillment-variants';
import Client from '../client';
import {flattenObject} from '../helpers';

const token = localStorage.getItem('token') || '';

class FulfillmentVariantsRepository {
  getFulfillmentVariants = async (actions: any) => {
    const makeRequest = new GetFulfillmentVariantsBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response};
  };

  createFulfillmentVariants = async (actions: any) => {
    const {callback, ...actionsPayload} = actions.payload;
    const makeRequest = new CreateFulfillmentVariantsBuilder()
      .data(flattenObject({...actionsPayload}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response, callback};
  };
}

export default new FulfillmentVariantsRepository();
